





































import Vue from 'vue'
import { BuyingOption } from '@/product/types/index'

export default Vue.extend({
  props: {
    buyingOptions: {
      type: Array as () => BuyingOption[],
      default: () => []
    },
    isBuying: {
      type: [Boolean, String],
      default: true
    }
  }
})
